export default word => word + "s";



// WEBPACK FOOTER //
// ./utils/pluralize.js